
import { Image as ImageComponent } from '@components/Image';
import clsx from 'clsx';

import { WagtailImage } from '@/types';

type Props = {
  image: WagtailImage;
  fullWidth: boolean;
};

function Image(props: Props) {
  const { fullWidth, image } = props;

  return (
    <div
      className={clsx('streamfield', 'image', {
        'image--full-width': fullWidth,
      })}
    >
      <ImageComponent
        className='image__element'
        image={image}
        quality={75}
        sizes='(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw'
        style={{
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
        }}
      />
    </div>
  );
}

export default Image;


